<template>
  <BaseSingleTemplate v-if="podcast">
    <template #template-label>
      <Label name="show" />
    </template>
    <template #share-button>
      <ShareButton />
    </template>
    <template #main-image>
      <ShowCarousel v-if="podcastPhotos.length" :images="podcastPhotos" />
      <picture v-else>
        <img
          :class="isArtistImageLoaded ? 'fade-in' : 'd-none'"
          :src="$router.options.imagePath + podcast.podcast.urlMedia"
          @load="isArtistImageLoaded = true"
        />
      </picture>
    </template>
    <template #data-info>
      <div class="data-info-container__header">
        <div class="data-info-container__header__item">
          <router-link :to="{name: 'location-id-shows', params: {id: podcast.podcast.locationModel.locationname}}">
            {{ podcast.podcast.locationModel.locationname }}
          </router-link>
        </div>
        <div class="data-info-container__header__item data-info-container__header__item--black">
          <span>
            {{ podcast.podcast.frequency }}
          </span>
        </div>
      </div>
      <h1 class="data-info-container__heading">
        {{ podcast.podcast.name }}
      </h1>
      <div class="data-info-container__subheading-container">
        <div class="data-info-container__subheading-container__item">
          <div class="data-info-container__subheading-container__col">
            <span>WITH RESIDENT HOST</span>
            <router-link
              :to="{
                name: 'Artist',
                params: { id: podcast.artist.permlink }
              }"
            >
              {{ podcast.artist.name }}
            </router-link>
          </div>
        </div>
      </div>
      <h4 class="data-info-container__subheading">
        SHOW DESCRIPTION
      </h4>
      <!-- eslint-disable-next-line vue/no-v-html -->
      <div class="data-info-container__content" v-html="podcast.podcast.description" />
      <div class="data-info-container__social">
        <template v-for="(social, key) in socialMediaModel">
          <div v-if="social"
               :key="key"
               class="data-info-container__social__item"
          >
            <a :href="social" target="_blank">
              {{ key }}
            </a>
          </div>
        </template>
        <div class="data-info-container__social__item">
          <ShareFacebook />
        </div>
      </div>
    </template>
    <template v-if="episodes.length" #episodes>
      <div class="episodes-container">
        <div class="episodes-container__inner">
          <SponsorEuCard v-if="isSponsored"
                         :artist-name="podcast.artist.name"
                         :show-name="podcast.podcast.name"
                         sponsor="sounds-now"/>
          <SponsorEuCard v-if="isSponsoredUlysses"
                         :artist-name="podcast.artist.name"
                         :show-name="podcast.podcast.name"
                         sponsor="ulysses"/>
          <SponsorEuCard v-if="isSponsoredEu"
                         :artist-name="podcast.artist.name"
                         :show-name="podcast.podcast.name"
                         sponsor="eu"/>
          <h4 class="episodes-single__heading">
            Episodes
          </h4>
          <div class="episodes-single__grid">
            <div v-for="episode in episodes"
                 :key="episode.id"
                 class="episodes-single__grid__item"
            >
              <EpisodeCard :episode="episode" :artist="episode.mainArtist" />
            </div>
            <div
              v-if="loading"
              class="episodes-single__grid__item episodes-single__grid__item--loader"
            >
              <Loading color="black" />
            </div>
            <div
              v-if="episodes.length && !loading && !pageLimit"
              class="episodes-single__grid episodes-single__grid--observer"
            >
              <IntersectionObserver :init-observer="initObserver" @intersect="loadEpisodes" />
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-if="episodes.length" #load-more>
      <div class="load-more">
        <div class="load-more__inner">
          <button
            v-if="!pageLimit"
            :disabled="loading"
            class="load-more__inner__button"
            @click="loadEpisodes"
          >
            <span>VIEW MORE EPISODES</span>
            <span>
              <img
                class="load-more__inner__icon"
                src="@/assets/icons/svg/arrow-down-icon-white.svg"
              />
            </span>
          </button>
          <span v-else>NO MORE EPISODES TO LOAD</span>
        </div>
      </div>
    </template>
    <template #artist-section>
      <div class="artist-section-container">
        <div class="artist-section-container__inner">
          <EpisodeArtistSection :main-artist="artistModel" />
        </div>
      </div>
    </template>
    <template v-if="podcast.similarPodcastsSet.length" #related-section>
      <div class="related-section">
        <div class="related-section__header">
          <div class="related-section__header__title">
            similar shows
          </div>
          <router-link
            :to="{ name: 'Residents', params: { id: 'all' } }"
            class="related-section__header__link"
          >
            view all
          </router-link>
        </div>
        <SimilarCarousel>
          <div
            v-for="similarPodcast in podcast.similarPodcastsSet"
            :key="similarPodcast.id"
            class="swiper-slide"
          >
            <ShowCard :show-data="similarPodcast" />
          </div>
        </SimilarCarousel>
      </div>
    </template>
  </BaseSingleTemplate>
</template>
<script>
import BaseSingleTemplate from '@/components/BaseSingleTemplate.vue';
import Label from '@/components/Label.vue';
import ShareButton from '@/components/ui/ShareButton.vue';
import Loading from '@/components/ui/Loading.vue';
import IntersectionObserver from '@/components/ui/IntersectionObserver.vue';
import ShareFacebook from '@/components/ui/ShareFacebook.vue';
import EpisodeCard from '@/components/cards/EpisodeCard.vue';
import ShowCard from '@/components/cards/ShowCard.vue';
import EpisodeArtistSection from '@/components/sections/EpisodeArtistSection.vue';
import ShowCarousel from '@/components/sections/ShowCarousel.vue';
import SimilarCarousel from '@/components/sections/SimilarCarousel.vue';
import axios from 'axios';
import SponsorEuCard from "@/components/cards/SponsorEuCard.vue";
export default {
  name: 'ShowSingle',
  components: {
    SponsorEuCard,
    Label,
    ShareButton,
    Loading,
    IntersectionObserver,
    ShareFacebook,
    BaseSingleTemplate,
    EpisodeCard,
    EpisodeArtistSection,
    ShowCarousel,
    SimilarCarousel,
    ShowCard
  },
  data() {
    return {
      loading: false,
      podcast: null,
      size: 16,
      page: 0,
      totalPages: null,
      artistId: null,
      episodes: [],
      artist: {},
      show: true,
      similarShows: [],
      podcastPhotos: [],
      selectedPodcastId: null,
      artistModel: {
        mainArtist: {
          permlink: 'alksdflskdjf',
          name: 'Voltnoi',
          mediaUrl: 'show/Hypermedium-Gunnpla--17092021.jpg',
          bio: 'bio of the artist'
        },
        podcast: { permlink: 'alksdflskdjf', name: 'Voltnoi' }
      },
      initObserver: false,
      isArtistImageLoaded: false,
      socialMediaModel: {},
      isSponsored: false,
      isSponsoredUlysses: false,
      isSponsoredEu: false
    };
  },

  computed: {
    pageLimit() {
      return this.page === this.totalPages - 1;
    }
  },

  created() {
    this.getPodcast();
  },

  mounted() {
    let mql = window.matchMedia('(max-width: 1200px)');
    if (mql.matches) this.initObserver = true;
    return false;
  },

  methods: {
    getPodcast() {
      axios
        .get(`${this.$router.options.api}/podcasts/perm/${this.$route.params.id}`)
        .then(response => {
          this.podcast = response.data;
          this.artistId = response.data.podcast.artistID;
          this.artistModel.mainArtist.frequency = response.data.artist.frequency;
          this.artistModel.mainArtist.mediaUrl = response.data.artist.mediaUrl;
          this.artistModel.mainArtist.name = response.data.artist.name;
          this.artistModel.mainArtist.permlink = response.data.artist.permlink;
          this.artistModel.mainArtist.bio = response.data.artist.bio;
          this.artistModel.podcast.name = response.data.podcast.name;
          this.artistModel.podcast.permlink = response.data.podcast.permlink;
          this.selectedPodcastId = response.data.podcast.id;
          this.isSponsored = response.data.podcast.sponsored;
          this.isSponsoredUlysses = response.data.podcast.sponsoredUlysses;
          this.isSponsoredEu = response.data.podcast.sponsoredEu;
          this.getEpisodesByShowId();

          this.podcastPhotos = this.mergePhotosToObject(
            response.data.podcast.urlMedia,
            response.data.podcast.podcastPhotos
          );
        })
        .catch(error => {
          console.error(error);
        });
    },

    getEpisodesByShowId() {
      this.loading = true;
      axios
        .get(
          this.$router.options.api +
            `/episode/podcast/${this.selectedPodcastId}?size=${this.size}&&page=${this.page}`
        )
        .then(response => {
          this.totalPages = response.data.totalPages;
          const apiData = response.data.content;
          this.episodes = [...this.episodes, ...apiData];
          this.loading = false;
        })
        .catch(e => {
          console.error(e.response);
        });
    },

    mergePhotosToObject(mainPhoto, photosArray) {
      let podcastPhotos = [];
      if (photosArray.length > 0) {
        const mapped = photosArray.map(e => ({ urlMedia: e.urlMedia }));
        const mainPhotoObject = { urlMedia: mainPhoto };
        podcastPhotos = [mainPhotoObject].concat(mapped);
        return podcastPhotos;
      } else {
        return [];
      }
    },

    loadEpisodes() {
      this.page++;
      this.scrollToPosition();
      this.getEpisodesByShowId();
    },

    scrollToPosition() {
      let mql = window.matchMedia('(max-width: 1200px)');
      if (mql.matches) return;
      setTimeout(() => {
        window.scrollBy({
          top: 900,
          left: 0,
          behavior: 'smooth'
        });
      }, 100);
    }
  }
};
</script>
